module.exports = __webpack_public_path__ + "static/media/ExperienceIcon.879bcaf4.svg";